import React from "react";
import { Navbar } from "./Navbar";
import { Link } from "react-router-dom";
import { PAGES_ENDPOINTS } from "../../config/api";
import { currentTenant } from "../../tenants";

export const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { companyName } = currentTenant;

  return (
    <div className="bg-gray-100 min-h-screen flex flex-col">
      {/* Navbar fissa in alto */}
      <Navbar />

      {/* Contenuto principale */}
      <main className="flex-grow max-w-7xl mx-auto p-6 w-full">
        {children}
      </main>

      {/* Footer in fondo */}
      <footer className="bg-white shadow-inner mt-8">
        <div className="max-w-7xl mx-auto py-6 px-6 flex flex-col sm:flex-row justify-between  text-sm text-gray-600">
          <div className="flex space-x-4">
            <p>© {new Date().getFullYear()} {companyName}. Tutti i diritti riservati.</p>
          </div>
          <div className="flex space-x-4 sm:mt-0">
            <Link to={PAGES_ENDPOINTS.COOKIES_PRIVACY} className="hover:underline">
              Cookie & Privacy Policy
            </Link>
            <Link to={PAGES_ENDPOINTS.CONDITIONS} className="hover:underline">
              Termini e Condizioni
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};
